import axios, { AxiosRequestConfig, AxiosResponse } from "axios"

import { PROFILE_STORAGE_KEY } from "../../Content/Global"
import { generateCsrfToken, getCsrfToken } from "../../utils/utils"
import {
  methods,
  SYMETRIC_SECRET_KEY_PROD,
  SYMETRIC_SECRET_KEY_DEV,
} from "./environment"
import { responseHandler } from "./responseHandler"
import CryptoJS from "crypto-js"
import { encryptedData, isFormData } from "../../utils/helper/encryptedUrl"

const clearProfileFromStorage = () => {
  try {
    localStorage.removeItem(PROFILE_STORAGE_KEY)
  } catch (error) {
    console.error("Error clearing profile from localStorage:", error)
  }
}

const makeRequest = async (
  endpoint: string,
  method: string,
  params?: any
): Promise<any> => {
  let SYMETRIC_SECRET_KEY =
    endpoint?.includes("dev") ||
    endpoint?.includes("article/trending-articles`")
      ? SYMETRIC_SECRET_KEY_DEV
      : SYMETRIC_SECRET_KEY_PROD
  const baseUrl = process.env.GATSBY_SYNKLI_API_ENDPOINT
  let updatedUrl = endpoint.startsWith("http")
    ? endpoint
    : `${baseUrl}${endpoint}`

  const appendQueryParams = (methods: any, currentMethod: string) => {
    return currentMethod == methods.get || currentMethod == methods.delete
  }

  let csrfToken = await getCsrfToken()
  if (!csrfToken) {
    csrfToken = await generateCsrfToken()
  }

  const customHeader: any = {
    "x-csrf-token": csrfToken,
    app_environment: "business_website",
  }

  if (params) {
    if (typeof params === "object") {
      if (updatedUrl.includes(":")) {
        for (const [k, v] of Object.entries(params) as [string, string][]) {
          updatedUrl = updatedUrl.replace(`:${k}`, v)
        }
      } else {
        updatedUrl = `${updatedUrl}?payload=${encodeURIComponent(
          encryptedData(params, SYMETRIC_SECRET_KEY)
        )}`
      }
    } else {
      updatedUrl = updatedUrl + "/" + params
    }
  }

  if (
    !updatedUrl?.includes("?") &&
    params &&
    appendQueryParams(methods, method)
  ) {
    updatedUrl = `${updatedUrl}?payload=${encodeURIComponent(
      encryptedData(params, SYMETRIC_SECRET_KEY)
    )}`
  }

  if (updatedUrl.endsWith("?")) {
    updatedUrl = updatedUrl.slice(0, -1)
  }
  if (updatedUrl?.includes("area=help")) {
    updatedUrl = updatedUrl.replace(/[?&]area=help&?/, match => {
      if (match.startsWith("?") && match.endsWith("&")) return "?"
      return ""
    })

    updatedUrl += `${
      updatedUrl.includes("?") ? "&" : "?"
    }payload=${encodeURIComponent(
      encryptedData({ area: "help" }, SYMETRIC_SECRET_KEY)
    )}`
  }

  let config: AxiosRequestConfig = {
    method: method,
    url: updatedUrl,
    data: isFormData(params)
      ? params
      : {
          ...(params && {
            payload: encryptedData(params, SYMETRIC_SECRET_KEY),
          }),
        },

    headers: customHeader,
    withCredentials: true,
  }

  if (appendQueryParams(methods, method)) {
    delete config.data
  }
  const res: AxiosResponse = await axios
    .request(config)
    .then(async (response: any) => {
      if (response?.data?.data?.is_encrypt) {
        const bytes = CryptoJS.AES.decrypt(
          response?.data.data.value,
          SYMETRIC_SECRET_KEY
        )
        const resp = bytes.toString(CryptoJS.enc.Utf8)

        const updatedResponse = {
          ...response,
          data: {
            ...response?.data,
            data: JSON.parse(resp),
          },
        }

        return updatedResponse
      }

      return response
    })
    .catch((error: any) => {
      return error.response
    })

  const status = res?.status
  let response: any = res?.data

  try {
    response["status"] = status
  } catch (error) {
    response = {}
  }

  if (response.status == 403) {
    await generateCsrfToken()
    return makeRequest(endpoint, method, params)
  }
  if (response.status == 401) {
    clearProfileFromStorage()
    window.location.href = "/"
    return
  }
  const finalResponse = responseHandler(response)

  return finalResponse
}

export default makeRequest
